import { EmblaCarouselType } from 'embla-carousel';

const addTogglePrevNextBtnsActive = (
  emblaApi: EmblaCarouselType,
  prevBtn: HTMLElement | null,
  nextBtn: HTMLElement | null
): (() => void) => {
  const togglePrevNextBtnsState = (): void => {
    if (prevBtn) {
      if (emblaApi.canScrollPrev()) prevBtn.removeAttribute('disabled');
      else prevBtn.setAttribute('disabled', 'disabled');
    }

    if (nextBtn) {
      if (emblaApi.canScrollNext()) nextBtn.removeAttribute('disabled');
      else nextBtn.setAttribute('disabled', 'disabled');
    }
  };

  emblaApi
    .on('select', togglePrevNextBtnsState)
    .on('init', togglePrevNextBtnsState)
    .on('reInit', togglePrevNextBtnsState);

  return (): void => {
    if (prevBtn) prevBtn.removeAttribute('disabled');
    if (nextBtn) nextBtn.removeAttribute('disabled');
  };
};

export const addPrevNextBtnsClickHandlers = (
  emblaApi: EmblaCarouselType,
  prevBtn: HTMLElement | null,
  nextBtn: HTMLElement | null
): (() => void) => {
  const scrollPrev = (): void => {
    emblaApi.scrollPrev();
  };
  const scrollNext = (): void => {
    emblaApi.scrollNext();
  };

  if (prevBtn) {
    prevBtn.addEventListener('click', scrollPrev, false);
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', scrollNext, false);
  }

  const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(
    emblaApi,
    prevBtn,
    nextBtn
  );

  return (): void => {
    removeTogglePrevNextBtnsActive();
    if (prevBtn) {
      prevBtn.removeEventListener('click', scrollPrev, false);
    }
    if (nextBtn) {
      nextBtn.removeEventListener('click', scrollNext, false);
    }
  };
}